<template>
    <y-modal
        ref="Modal"
        :title="title"
    >
        <div slot="body">
            <form
                id="spec-form"
                @submit.prevent="submit(save)"
            >
                <y-form-field
                    v-for="locale in locales"
                    :key="`title-${locale}`"
                    v-model="model.title[locale]"
                    type="text"
                    :name="`title-${locale}`"
                    validation="required"
                    :label="$t('specs.group.locale_title', { locale: $t(`general.locales.${locale}`) })"
                />
                <y-form-field
                    v-model="model.type"
                    type="select"
                    name="type"
                    :options="types"
                    validation="required"
                />
            </form>
        </div>

        <template slot="footer">
            <div class="ta-l w-100">
                <y-button
                    class="ml5"
                    @click.prevent.native="close"
                >
                    {{ $t('button.cancel') }}
                </y-button>
                <y-button
                    color="blue"
                    form="spec-form"
                    loading-on="submitting-form"
                >
                    {{ $t('button.save') }}
                </y-button>
            </div>
        </template>
    </y-modal>
</template>

<script>

    import FormMixin from '@/mixins/Form';
    import { YModal, YFormField } from '@deps';

    export default {
        name: 'SpecModal',

        components: {
            YModal,
            YFormField,
        },

        mixins: [FormMixin],

        props: {
            locales: {
                type: Array,
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                edit      : false,
                groupIndex: null,
                index     : null,

                types: [
                    {
                        label: this.$t('specs.types.text'),
                        value: 'text',
                    },
                    {
                        label: this.$t('specs.types.textarea'),
                        value: 'textarea',
                    },
                    {
                        label: this.$t('specs.types.boolean'),
                        value: 'boolean',
                    },
                ],

                model: {
                    title: {},
                    type : 'text',
                },
            };
        },

        computed: {
            /**
             * Return modal title
             */
            title() {
                return this.edit ? this.$t('specs.spec_item.edit_modal') : this.$t('specs.spec_item.create_modal');
            },
        },

        methods: {

            /**
             * Save form
             */
            save() {
                return new Promise((resolve) => {
                    this.$emit('save', {
                        edit      : this.edit,
                        groupIndex: this.groupIndex,
                        index     : this.index,
                        model     : this.model,
                    });
                    this.close();
                    resolve();
                });
            },

            /**
             * Open modal
             *
             * @param edit
             * @param groupIndex
             * @param index
             * @param model
             */
            open(edit = false, groupIndex = null, index = null, model = null) {
                this.edit = edit;
                this.groupIndex = groupIndex;
                this.index = index;
                if (model) {
                    this.model = model;
                }
                this.$refs.Modal.open();
            },

            /**
             * Close modal
             */
            close() {
                this.$refs.Modal.close();
                this.reset();
            },

            /**
             * Reset modal data
             */
            reset() {
                this.edit = false;
                this.groupIndex = null;
                this.index = null;
                this.model = {
                    title: {},
                    type : 'text',
                };
            },

        },
    };
</script>
